// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UWS2","newExpiryDate":"styles_newExpiryDate__3UuQx","footer":"styles_footer__2U5Rf"};